import styled, { css } from 'styled-components';
import { mobile, tv } from 'app/device';

export const SearchBoxWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-self: center;
    height: 60vh;
    justify-content: flex-end;
    width: 800px;
    max-width: 98vw;
    margin-bottom: 30px;
    flex-shrink: 0;

    ${mobile(css`
        margin-top: 25vh;
        margin-bottom: -20px;
        width: auto;
        min-width: 45vw;
    `)}

    ${tv(css`
        width: 60vw;
        max-width: 1000px;
    `)}
`;
